import { render } from "./icon-view-list.vue?vue&type=template&id=61a88f84"
import script from "./icon-view-list.vue?vue&type=script&lang=js"
export * from "./icon-view-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__